import MuiSlider from "@mui/material/Slider";
import { Button, GridColumn } from "designSystem/index";
import React from "react";

export default () => {
	return (
		<GridColumn
			spacing={3}
			spacingAroundX={1}
			spacingAroundY={15}
		>
			<MuiSlider
				max={5}
				min={1}
			/>
			<Button
				design="primary"
				res="Submit"
			/>
		</GridColumn>
	);
};